Octopus.Model = Octopus.Model || {};

Octopus.Model.AutomaticExpander = function (rootNode) {
    var self = this;

    // Modes:
    //  All
    //  Errors
    //  None
    //  Interesting (errors and currently running)
    //  Custom
    self.mode = "Interesting";

    self.setMode = function (mode) {
        self.mode = mode;
        self.refresh();
        self.changed();
    };

    self.isExpanded = function (node) {
        if (self.mode === "Custom") {
            return node.isExpanded;
        } else if (self.mode === "All") {
            return true;
        } else if (self.mode === "Errors") {
            return node.hasErrors;
        } else if (self.mode === "Interesting") {
            return node.id === rootNode.id || node.hasErrors || node.showAtSummaryLevel || node.status === "Pending" || node.status === "Running" || node.status === "SuccessWithWarning" || node.status === "Canceled";
        } else if (self.mode === "None") {
            return false;
        }
    };

    var expand = function (node) {
        var childExpanded = false;
        for (var i = 0; i < node.children.length; i++) {
            if (expand(node.children[i])) {
                childExpanded = true;
            }
        }

        if (childExpanded) {
            node.isExpanded = true;
            return true;
        }

        if (self.isExpanded(node)) {
            node.isExpanded = true;
            return true;
        } else {
            node.isExpanded = false;
            return false;
        }
    };

    self.refresh = function () {
        if (self.mode === "Custom") {
            return;
        }
        expand(rootNode);
    };

    self.changed = function () {
        rootNode.updateCount++;
    };

    return self;
};

Octopus.Model.LogTreeNode = function () {
    var self = this;
    self.id = null;
    self.status = null;
    self.children = [];
    self.name = null;
    self.started = null;
    self.ended = null;
    self.logElements = [];
    self.childrenById = {};
    self.updateCount = 0;
    self.progressMessage = "";
    self.progressPercentage = 0;
    self.showAtSummaryLevel = false;
    self.counter = 0;
    self.isExpanded = false;
    self.expander = new Octopus.Model.AutomaticExpander(self);
    self.additionalEntries = 0;

    self.toggleExpanded = function () {
        if (!self.isExpanded) {
            self.expandSingleNodes();
        }
        else {
            self.isExpanded = false;
        }
        if (self.expander) {
            self.expander.mode = "Custom";
        }
    };

    self.expandSingleNodes = function () {
        self.isExpanded = true;
        if (self.children.length === 1) {
            self.children[0].expandSingleNodes();
        }
    };

    self.expandTo = function (e) {
        return self.expandToId(e.id);
    };

    self.expandToId = function (id) {
        if (id === self.id) {
            self.isExpanded = true;
            return true;
        } else {
            for (var q = 0; q < self.children.length; q++) {
                if (self.children[q].expandToId(id)) {
                    self.isExpanded = true;
                    if (self.expander) {
                        self.expander.mode = "Custom";
                    }
                    return true;
                }
            }

            self.isExpanded = false;
        }

        return false;
    };

    self.update = function (element) {
        self.id = element.Id;
        self.name = element.Name;
        self.status = element.Status;
        self.started = element.Started;
        self.ended = element.Ended;
        self.updateCount++;
        self.progressPercentage = element.ProgressPercentage;
        self.progressMessage = element.ProgressMessage;
        self.showAtSummaryLevel = element.ShowAtSummaryLevel;
        self.hasErrors = false;
        self.additionalEntries = element.AdditionalEntries;

        if (element.Children) {
            for (var i = 0; i < element.Children.length; i++) {
                var child = element.Children[i];
                if (!self.childrenById[child.Id]) {
                    self.childrenById[child.Id] = new Octopus.Model.LogTreeNode();
                    self.childrenById[child.Id].expander = self.expander;
                    self.children.push(self.childrenById[child.Id]);
                }

                self.childrenById[child.Id].update(child);
                self.hasErrors = self.hasErrors || self.childrenById[child.Id].hasErrors;
            }
        }

        if (element.LogElements) {
            var shuffling = false;
            for (var j = 0; j < element.LogElements.length; j++) {
                var source = element.LogElements[j];
                var target;
                if (j < self.logElements.length) {
                    target = self.logElements[j];

                    if (shuffling ||
                        target.Category !== source.Category ||
                        target.OccurredAt !== source.OccurredAt ||
                        target.MessageText !== source.MessageText) {
                        target.MessageText = source.MessageText;
                        target.Category = source.Category;
                        target.OccurredAt = source.OccurredAt;
                        shuffling = true;
                        self.counter = self.counter + 1;
                    }
                } else {
                    self.logElements.push(source);
                    target = source;
                    self.counter = self.counter + 1;
                }

                if (target.Category === "Error" || target.Category === "Fatal") {
                    self.hasErrors = true;
                }

                target.DetailedMessageText = source.MessageText;

                if (source.Detail) {
                    target.DetailedMessageText = target.DetailedMessageText + '\n' + source.Detail;
                }
            }
        }
    };

    self.refresh = function (element) {
        self.update(element);
        self.expander.refresh();
    };
};





//////////////////
// WEBPACK FOOTER
// ./app/model/log_tree_node.js
// module id = 8514030299461830
// module chunks = 1